export default __webpack_public_path__ + "3391cdaed89c6424e4c5ef706f4962e9.jpg";